import styled from "styled-components";
import { mobile } from "../utilities/responsive";

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 2;

  ${mobile({
    position: "absolute" /* Rail becomes part of the document */,
    background: "black" /* Paints the black column itself */,
  })}
`;

const Wrapper = styled.div`
  width: 60px;
  height: 100%;
  /* v42: svh — the SMALL viewport height. dvh tracked the Safari bottom bar
     collapse mid-scroll, growing the sticky wrapper ~40pt and sliding the
     center-anchored dots (Δ/2) and bottom-anchored HOME/BACK (Δ) as you
     scroll. svh ignores the bar state, so the rail content never moves. */
  height: 100svh;  display: flex;
  color: white;

  box-sizing: border-box;
  margin: 0;
  padding: 0;
  overflow: hidden;

  ${mobile({
    position: "sticky" /* Content box rides the document */,
    top: "0",
    overflow: "visible", /* Fixes mobile menu visibility */
    minWidth: "30px" /* Shrink-wraps the container to */,
    width: "calc(5vw + 11px)" /* Rail width fixed double-width bug */,
  })}
`;

const Nav = styled.nav`
  border-right: 0.5px solid #444;
  min-width: 60px;
  width: 60px;
  position: relative;
  background: black;
  z-index: 3;

  ${mobile({
    minWidth: "30px",
    width: "calc(5vw + 10px)",
  })}
`;

const Logo = styled.div`
  position: absolute;
  top: 50px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 2rem;

  ${mobile({
    fontSize: "1.8rem",
  })}
`;

const Dot = styled.span`
  display: block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: white;
  transition: all ease 0.3s;
`;

const DotContainer = styled.label`
  height: 50px;
  width: 60px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  cursor: pointer;

  ${mobile({
    minWidth: "30px",
    width: "calc(5vw + 10px)",
  })}

  &:hover > ${Dot}:nth-child(1) {
    transform: translate(5px, 5px);
  }

  &:hover > ${Dot}:nth-child(3) {
    transform: translate(-5px, -5px);
  }
`;

const Text = styled.div`
  position: absolute;
  transform: translateX(-50%) rotate(-90deg);
  bottom: 100px;
  left: 50%;
  white-space: nowrap;
  text-transform: uppercase;
  font-family: sans-serif;
  cursor: pointer;
  font-size: 0.8rem;
  letter-spacing: 1.5px;
`;

const NavDetails = styled.div`
  position: absolute;
  left: 60px;
  top: 50%;
  height: calc(100vh - 20px);
  height: calc(100svh - 20px);
  background: #eee;
  color: black;
  width: 600px;
  max-width: calc(100vw - 60px);
  transform: translateY(-50%);
  border-top-right-radius: 1rem;
  border-bottom-right-radius: 1rem;
  overflow: hidden;
  padding: 30px;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  padding-bottom: 100px;
  transition:
    transform 0.3s ease,
    opacity 0.3s ease;

  ${mobile({
    maxWidth: "calc(98vw - 30px)",
    left: "30px",
  })}
`;

const Rows = styled.div``;

const Row = styled.div`
  line-height: 6rem;
  font-size: 6rem;
  white-space: nowrap;
  margin: 20px 0;
  color: #444;
  cursor: pointer;
  transition: color 0.5s ease;
  overflow: hidden;

  @keyframes marquee {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(-100%, 0);
    }
  }

  & > span {
    display: inline-block;
    padding-left: 100%;
    animation: marquee 10s linear infinite;
  }
`;

const RowMid = styled.div`
  line-height: 6rem;
  font-size: 6rem;
  white-space: nowrap;
  margin: 20px 0;
  color: #444;
  cursor: pointer;
  transition: color 0.5s ease;
  overflow: hidden;

  & > span {
    display: inline-block;
    padding-left: 100%;
    animation: marquee 10s linear reverse infinite;
    animation-delay: 1s;
  }
`;

const HR = styled.hr``;

const Hello = styled.div``;

const H4 = styled.h4`
  text-transform: uppercase;
  color: #aaa;
  font-family: sans-serif;
  margin-top: 3rem;
`;

const Email = styled.a`
  color: inherit;
  text-decoration: none;
  margin: 0;
  padding: 0;
  font-size: 1.3rem;
`;

const NavBtn = styled.input`
  display: none;
  visibility: hidden;

  &:not(:checked) ~ ${Wrapper} > ${NavDetails} {
    transform: translateX(-100%) translateY(-50%);
    opacity: 0;
  }
`;

const Exit = styled.label`
  cursor: pointer;
  font-weight: 500;
  font-size: 20px;
  color: black;
  padding: 1.1rem;
  position: absolute;
  top: 0;
  right: 0;
`;

const SideMenu = () => {
  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    const btn = document.getElementById("nav-btn");
    if (btn) btn.checked = false;
  };

  const goHome = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const btn = document.getElementById("nav-btn");
    if (btn) btn.checked = false;
  };

  const openMail = () => {
    window.open(
      "https://mailhide.io/e/kWBSwZsz",
      "mailhidepopup",
      "width=580,height=635",
    );
  };

  return (
    <Container>
      <NavBtn type="checkbox" id="nav-btn"></NavBtn>
      <Wrapper>
        <Nav>
          <Logo>A</Logo> {/* REPLACE WITH GRAPHIC LOGO */}
          <DotContainer htmlFor="nav-btn">
            <Dot></Dot>
            <Dot></Dot>
            <Dot></Dot>
          </DotContainer>
          <Text onClick={goHome} style={{ cursor: "pointer" }}>
            Home / Back
          </Text>
        </Nav>
        <NavDetails>
          <Exit htmlFor="nav-btn" className="test">
            &#x2715;
          </Exit>
          <Rows>
            <HR />
            <Row onClick={() => go("projects")}>
              <span>
                Work * WORK * <b>work</b> * Work
              </span>
            </Row>
            <HR />
            <RowMid onClick={() => go("reviews")}>
              <span>
                Feedback * <i>FEEDBACK</i> * feedback * Feedback
              </span>
            </RowMid>
            <HR />
            <Row onClick={openMail}>
              <span>
                <b>Contact</b> * Contact * CONTACT
              </span>
            </Row>
            <HR />
          </Rows>
          <Hello>
            <H4>Say Hello</H4>{" "}
            <Email
              href="https://mailhide.io/e/kWBSwZsz"
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => {
                e.preventDefault();
                window.open(
                  "https://mailhide.io/e/kWBSwZsz",
                  "mailhidepopup",
                  "width=580,height=635",
                );
              }}
            >
              a......@gmail.com
            </Email>
          </Hello>
        </NavDetails>
      </Wrapper>
    </Container>
  );
};

export default SideMenu;
